import { useQuery } from "react-query";
import APIURL from "../axios";

const getESim = (uuid, lang) => {
  return APIURL.get(`/${uuid}/sims/companies`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      lang,
    },
  });
};

export const ShowESim = (uuid, lang) => {
  return useQuery(["sims", uuid, lang], () => getESim(uuid, lang));
};

const get_eSimPackages = (uuid, lang, company_uuid, type) => {
  return APIURL.get(`/${uuid}/sims/packages/${company_uuid}?type=${type}`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      lang,
    },
  });
};
export const SimPackages = (uuid, lang, company_uuid, type) => {
  return useQuery(["sim-packages", uuid, lang, type], () =>
    get_eSimPackages(uuid, lang, company_uuid, type)
  );
};

export const bookSimReq = (uuid, lang, data) => {
  console.log(data, "sldfjsdoifusodifuosiduf");
  return APIURL.post(`/${uuid}/sims/book-sim`, data, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      lang,
    },
  });
};

export const BookSim = (uuid, lang, data) => {
  return useQuery(["book-sim", uuid, lang], () => bookSimReq(uuid, lang, data));
};
